function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import SiteActivityTabs from "../../components/site-activity-tabs";
import { withRouter } from "react-router";
import { SimpleContainer, CssContainer } from "../../components/container";
import { ActivityContainer, ActivityTrendsHeader, ActivityData } from "../../components/container-activity";
import { KpiStrip, Kpi } from '../../components/card';
import { Loader, EllipsisLoader } from '../../components/loaders';
import { BaseDataViewComponentAsync, BaseGridViewComponent } from "../../components/base";
import Error from '../../components/error';
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import currencyFormat from "../../functions/currency";
import ActivityPagesGrid from "../../components/activity-pages-grid";
import ActivityPagesLocationGrid from "../../components/activity-pages-location-grid";
import Query from '../../functions/query';
import rangeLabel from "../../functions/range-label";
import ServiceFactory from '../../service';
import account from "../../data/account";
import groupByLabel from "../../functions/groupBy-label";
import compLabel from "../../functions/comp-label";
import GroupFilter from "../../components/group-filter";
import snakeToCamel from "../../functions/snake-to-camel";
import PlunkDropDown from "../../components/plunk-dropdown";
import { getGlobalRange, getGlobalComp, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
class MainComponent extends BaseGridViewComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "onPageRequest", page => {
      this.gotoPage(page);
    });
    _defineProperty(this, "onSelected", e => {
      var comp = this.comp;
      var item = e.detail.item;
      var range = item.dataset.value;
      this.fetchScoreCard = true;
      var redirectUrl = this.redirectUrl(range, comp);
      this.gotoPage(redirectUrl);
    });
    _defineProperty(this, "onCompSelected", e => {
      var item = e.detail.item;
      var range = this.range;
      var comp = item.dataset.value;
      if (comp === 'unavailable') {
        return;
      }
      this.fetchChartData = true;
      var redirectUrl = this.redirectUrl(range, comp);
      this.gotoPage(redirectUrl);
    });
    _defineProperty(this, "onPagesLocationGroupBySelected", e => {
      var item = e.detail.item;
      var groupBy = item.dataset.value;
      var range = this.range;
      var comp = this.comp;
      //this.props.history.push(`/Activity/Pages/Location/${range}/${comp}/${groupBy}`);
      this.gotoPage(`/Activity/Pages/Location/${range}/${comp}/${groupBy}`);
    });
    _defineProperty(this, "onSiteSelected", host => {
      if (!host) {
        this.setState({
          siteHost: null,
          hostPages: null
        });
        return;
      }
      this.setState({
        siteHost: host,
        hostPages: null
      });
      this.fetchHostPages(host);
    });
    this.fetchScoreCard = false;
    // §290 site filter: hosts = /v1/activity/hosts/{range} rows (the
    // dropdown shows only when >1 host reported traffic); siteHost null
    // = the merged view (unchanged legacy path). Host-filtered numbers
    // read DAY rows via /hosts/pages — no comparison exists there, so
    // the filtered state renders its own honest table, not the grids.
    this.state = {
      showLoader: true,
      data: null,
      hosts: null,
      siteHost: null,
      hostPages: null,
      hostLoading: false
    };
  }
  async componentDidMount() {
    publishSearch('Pages', true, 'pages', 'url', 'Url');
    publishEvent('reset-search', {});
    await this.fetch();
    this._periodTok = subscribePeriod(({
      range,
      comp
    }) => {
      if (window.location.pathname.indexOf('/Activity/Pages') !== 0) return;
      const r0 = range || getGlobalRange();
      const r = String(r0).indexOf('custom') === 0 ? 'this_month' : r0;
      const c = comp || this.comp;
      this.gotoPage(`/Activity/Pages/${r}/${c}`);
    });
  }
  componentWillUnmount() {
    unsubscribePeriod(this._periodTok);
  }
  async componentDidUpdate() {
    console.log('update');
    if (this.fetchScoreCard) {
      await this.fetch();
    }
  }
  get isLocationView() {
    var path = location.pathname;
    path = path.toLowerCase();
    return path.includes('/location');
  }
  get range() {
    var range = this.props.params.range;
    if (!range) range = getGlobalRange();
    if (String(range).indexOf('custom') === 0) range = 'this_month';
    return range;
  }
  get comp() {
    var comp = this.props.params.comp;
    if (!comp) comp = getGlobalComp();
    return comp;
  }
  get compRange() {
    var range = this.range;
    var comp = this.comp;
    if (comp === 'prev_period') {
      range += '_prev';
    }
    return range;
  }
  get groupBy() {
    var groupBy = this.props.params.groupBy;
    if (!groupBy) groupBy = 'city';
    return groupBy;
  }
  get hideComp() {
    return this.range === 'all_time';
  }

  //base Urls use range/comp
  get baseUrl() {
    var range = this.range;
    var comp = this.comp;
    var baseUrl = `/Activity/Pages/${range}/${comp}`;
    return baseUrl;
  }
  get pagesLocationBaseUrl() {
    var range = this.range;
    var comp = this.comp;
    var groupBy = this.groupBy;
    var baseUrl = `/Activity/Pages/Location/${range}/${comp}/${groupBy}`;
    return baseUrl;
  }
  get refreshUrl() {
    return `/Activity/Pages/this_month/prev_year`;
  }
  get pagesLocationRefreshUrl() {
    return `/Activity/Pages/Location/this_month/prev_year/city`;
  }
  redirectUrl(range, comp) {
    var groupBy = this.groupBy;
    if (this.isLocationView) {
      return `/Activity/Pages/Location/${range}/${comp}/${groupBy}`;
    } else {
      return `/Activity/Pages/${range}/${comp}`;
    }
  }
  async fetch() {
    await this.fetchData();
  }
  async fetchData() {
    var api = `/metrics/page/scorecard/${this.range}`;
    var Service = ServiceFactory.getType(api);
    var service = new Service();
    try {
      let data = await service.getAsync();
      console.log(data);
      this.fetchScoreCard = false;
      this.setState({
        showLoader: false,
        data: data
      });
    } catch (err) {
      console.log(err);
    }
    await this.fetchHosts();
  }
  async fetchHosts() {
    // Fail-soft: the filter is decoration on the merged view — an error
    // here just hides the dropdown.
    try {
      var Service = ServiceFactory.getType(`/hosts/${this.range}`);
      var d = await new Service().getAsync();
      var hosts = d && d.hosts || [];
      this.setState({
        hosts: hosts
      });
      var sel = this.state.siteHost;
      if (sel) {
        if (hosts.some(h => h.host === sel)) await this.fetchHostPages(sel);else this.setState({
          siteHost: null,
          hostPages: null
        });
      }
    } catch (err) {
      this.setState({
        hosts: []
      });
    }
  }
  async fetchHostPages(host) {
    this.setState({
      hostLoading: true
    });
    try {
      var Service = ServiceFactory.getType(`/hosts/pages/${this.range}?host=${encodeURIComponent(host)}&top=100`);
      var d = await new Service().getAsync();
      this.setState({
        hostPages: d && d.pages || [],
        hostLoading: false
      });
    } catch (err) {
      this.setState({
        hostPages: [],
        hostLoading: false
      });
    }
  }
  render() {
    var range = this.range;
    var selection = rangeLabel(range);
    var groupBy = this.groupBy;
    var groupByColumn = snakeToCamel(groupBy);
    var data = this.props.data;
    var baseUrl = this.baseUrl;
    var refreshUrl = this.refreshUrl;
    var pagesLocationBaseUrl = this.pagesLocationBaseUrl;
    var pagesLocationRefreshUrl = this.pagesLocationRefreshUrl;
    var cardData = this.state.data;
    var accountData = account.get();
    var domain = accountData.domain;
    var selection = rangeLabel(range);
    var groupLabel = groupByLabel(groupBy);
    var compSelection = compLabel(this.comp);
    var compHide = range === 'all_time';
    var hosts = this.state.hosts || [];
    var siteHost = this.state.siteHost;
    var hostRow = siteHost ? hosts.find(h => h.host === siteHost) : null;
    var hostPages = this.state.hostPages;
    var fmt = v => currencyFormat(v, 0, '');
    var siteFilter = hosts.length > 1 ? /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        justifyContent: 'flex-end',
        padding: '4px 40px 8px'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 13
      }
    }, "Site:"), /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "240px",
      value: siteHost || '',
      onChange: this.onSiteSelected,
      options: [['', 'All sites'], ...hosts.map(h => [h.host, h.host])]
    })) : null;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SiteActivityTabs, null), /*#__PURE__*/React.createElement(ActivityContainer, null, /*#__PURE__*/React.createElement(ActivityTrendsHeader, {
      title: "Pages Activity",
      hideControls: true,
      selection: selection,
      id: "pages",
      onSelected: this.onSelected,
      compId: "product-comp",
      onCompSelected: this.onCompSelected,
      compSelection: compSelection,
      comp: this.comp,
      range: range,
      compHide: compHide
    }), siteFilter, this.state.showLoader ? /*#__PURE__*/React.createElement(EllipsisLoader, {
      cls: "loader-container auto"
    }) : hostRow ? /*#__PURE__*/React.createElement(ActivityData, null, /*#__PURE__*/React.createElement(KpiStrip, null, /*#__PURE__*/React.createElement(Kpi, {
      label: "Site",
      value: hostRow.host
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Views",
      value: fmt(hostRow.views)
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Sessions",
      value: fmt(hostRow.sessions)
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Visitors",
      value: fmt(hostRow.visitors)
    }))) : /*#__PURE__*/React.createElement(ActivityData, null, /*#__PURE__*/React.createElement(KpiStrip, null, /*#__PURE__*/React.createElement(Kpi, {
      label: "Total Pages",
      value: currencyFormat(cardData.totalPages, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Views",
      value: currencyFormat(cardData.views, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Sessions",
      value: currencyFormat(cardData.sessions, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Users",
      value: currencyFormat(cardData.uniqueUsers, 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Avg Time Span",
      value: currencyFormat(cardData.avgTimeSpanString, 2, '')
    })))), siteHost ? /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "margin-squeeze"
    }, /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        marginTop: 0
      }
    }, "Showing ", siteHost, " only \u2014 top pages from day-level data. Comparisons and location breakdowns apply to the merged view; pick \"All sites\" to get them back."), this.state.hostLoading || !hostPages ? /*#__PURE__*/React.createElement(EllipsisLoader, {
      cls: "loader-container auto"
    }) : hostPages.length === 0 ? /*#__PURE__*/React.createElement("p", {
      className: "module-empty"
    }, "No page data recorded for ", siteHost, " in this period.") : /*#__PURE__*/React.createElement("table", {
      className: "territory-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Page"), /*#__PURE__*/React.createElement("th", {
      className: "num"
    }, "Views"), /*#__PURE__*/React.createElement("th", {
      className: "num"
    }, "Sessions"), /*#__PURE__*/React.createElement("th", {
      className: "num"
    }, "Visitors"), /*#__PURE__*/React.createElement("th", {
      className: "num"
    }, "Avg Time"))), /*#__PURE__*/React.createElement("tbody", null, hostPages.map((p, i) => {
      // day rows carry the PATH; resolve against the host
      // (app:// surfaces get no link — nothing to open)
      var h = p.host || siteHost;
      var href = /^https?:/i.test(p.url) ? p.url : h && !/^app:/i.test(h) ? `https://${h}${p.url}` : null;
      return /*#__PURE__*/React.createElement("tr", {
        key: `${p.url}|${i}`
      }, /*#__PURE__*/React.createElement("td", null, href ? /*#__PURE__*/React.createElement("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer"
      }, p.title || p.url) : p.title || p.url), /*#__PURE__*/React.createElement("td", {
        className: "num",
        style: {
          textAlign: 'right'
        }
      }, fmt(p.views)), /*#__PURE__*/React.createElement("td", {
        className: "num",
        style: {
          textAlign: 'right'
        }
      }, fmt(p.sessions)), /*#__PURE__*/React.createElement("td", {
        className: "num",
        style: {
          textAlign: 'right'
        }
      }, fmt(p.visitors)), /*#__PURE__*/React.createElement("td", {
        className: "num",
        style: {
          textAlign: 'right'
        }
      }, p.avgTimespan != null ? Math.round(Number(p.avgTimespan)) + 's' : '—'));
    })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(ActivityPagesGrid, {
      refreshUrl: refreshUrl,
      baseUrl: baseUrl,
      data: data,
      comparison: this.props.comparison,
      domain: domain,
      pagination: this.props.pagination,
      onPageRequest: this.onPageRequest
    })), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GroupFilter, {
      id: "groupBy-filter-2",
      name: "Pages Location: ",
      color: "orange",
      selection: groupLabel,
      onSelected: this.onPagesLocationGroupBySelected
    }))), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(ActivityPagesLocationGrid, {
      refreshUrl: pagesLocationRefreshUrl,
      baseUrl: pagesLocationBaseUrl,
      data: this.props.pagesLocationData,
      range: range,
      domain: domain,
      column: groupByColumn,
      comparison: this.props.pagesLocationComparison,
      pagination: this.props.pagesLocationPagination,
      onPageRequest: this.onPageRequest
    }))));
  }
}
export class ActivityPagesViewComponent extends BaseDataViewComponentAsync {
  constructor(props) {
    super(props);
  }
  get isLocationView() {
    var path = location.pathname;
    path = path.toLowerCase();
    return path.includes('/location');
  }
  get defaultPage() {
    var isLocationView = this.isLocationView;
    if (!isLocationView) return this.page;else return 1;
  }
  get pagesLocationPage() {
    var isLocationView = this.isLocationView;
    if (isLocationView) return this.page;else return 1;
  }
  get range() {
    var range = this.props.params.range;
    if (!range) range = getGlobalRange();
    if (String(range).indexOf('custom') === 0) range = 'this_month';
    return range;
  }
  get comp() {
    var comp = this.props.params.comp;
    if (!comp) comp = getGlobalComp();
    return comp;
  }
  get compRange() {
    var range = this.range;
    var comp = this.comp;
    if (comp === 'prev_period') {
      range += '_prev';
    }
    return range;
  }
  get groupBy() {
    var groupBy = this.props.params.groupBy;
    if (!groupBy) groupBy = 'city';
    return groupBy;
  }
  //apis use range
  get api() {
    var range = this.range;
    var api = `/metrics/page/${range}`;
    var where = this.where;
    if (!this.isLocationView && where) {
      api += '?$where=' + where;
    }
    return api;
  }
  get pagesLocationApi() {
    var range = this.range;
    var groupBy = this.groupBy;
    var api = `/metrics/page-location/${range}/${groupBy}`;
    var where = this.where;
    if (this.isLocationView && where) {
      api += '?$where=' + where;
    }
    return api;
  }
  //comparison apis use compRange
  get comparisonApi() {
    var compRange = this.compRange;
    var api = `/metrics/trends/page-stats/${compRange}`;
    return api;
  }
  get comparisonPagesLocationApi() {
    var compRange = this.compRange;
    var groupBy = this.groupBy;
    var api = `/metrics/trends/page-location-stats/${compRange}/${groupBy}`;
    //var api = `/metrics/trends/page-location-stats/all_time/${groupBy}`;
    return api;
  }

  //base Urls use range/comp
  get baseUrl() {
    var range = this.range;
    var comp = this.comp;
    var baseUrl = `/Activity/Pages/${range}/${comp}`;
    return baseUrl;
  }
  get pagesLocationBaseUrl() {
    var range = this.range;
    var comp = this.comp;
    var groupBy = this.groupBy;
    var baseUrl = `/Activity/Pages/Location/${range}/${comp}/${groupBy}`;
    return baseUrl;
  }
  get orderBy() {
    let query = this.queryParams;
    let orderBy = query.get('$orderBy');
    return orderBy;
  }
  get orderByDesc() {
    let query = this.queryParams;
    let orderBy = query.get('$orderBy');
    let orderByDesc = query.get('$orderByDesc');
    if (!orderBy && !orderByDesc) {
      orderByDesc = 'Views';
    }
    return orderByDesc;
  }
  get defaultOrderBy() {
    if (!this.isLocationView) {
      return this.orderBy;
    } else {
      return null;
    }
  }
  get defaultOrderByDesc() {
    if (!this.isLocationView) {
      return this.orderByDesc;
    } else {
      return 'Views';
    }
  }
  get pagesLocationOrderBy() {
    if (this.isLocationView) {
      return this.orderBy;
    } else {
      return null;
    }
  }
  get pagesLocationOrderByDesc() {
    if (this.isLocationView) {
      return this.orderByDesc;
    } else {
      return 'Views';
    }
  }
  get where() {
    let query = this.queryParams;
    let where = query.get('$where');
    return where;
  }
  async fetchData() {
    let page = this.defaultPage;
    let pagesLocationPage = this.pagesLocationPage;
    var groupBy = this.groupBy;
    var groupByColumn = snakeToCamel(groupBy);
    var api = this.api;
    var comparisonApi = this.comparisonApi;
    var pagesLocationApi = this.pagesLocationApi;
    var comparisonPagesLocationApi = this.comparisonPagesLocationApi;
    var Service = ServiceFactory.getType(api);
    var service = new Service();
    var ComparisonService = ServiceFactory.getType(comparisonApi);
    var comparisonService = new ComparisonService();
    var PagesLocationService = ServiceFactory.getType(pagesLocationApi);
    var pagesLocationService = new PagesLocationService();
    var PagesLocationComparisonService = ServiceFactory.getType(comparisonPagesLocationApi);
    var pagesLocationComparisonService = new PagesLocationComparisonService();
    var baseUrl = this.baseUrl;
    var pagesLocationBaseUrl = this.pagesLocationBaseUrl;
    var defaultOrderBy = this.defaultOrderBy;
    var defaultOrderByDesc = this.defaultOrderByDesc;
    var pagesLocationOrderBy = this.pagesLocationOrderBy;
    var pagesLocationOrderByDesc = this.pagesLocationOrderByDesc;
    try {
      let data = await service.paginate({
        baseUrl: baseUrl,
        rawUrl: location.href,
        page: page,
        pageSize: 10
      }).orderBy(defaultOrderBy).orderByDesc(defaultOrderByDesc).getAsync();
      console.log(data);
      let pagesLocationData = await pagesLocationService.paginate({
        baseUrl: pagesLocationBaseUrl,
        rawUrl: location.href,
        page: pagesLocationPage,
        pageSize: 10
      }).orderBy(pagesLocationOrderBy).orderByDesc(pagesLocationOrderByDesc).getAsync();
      console.log(pagesLocationData);
      let comparison = [];
      let pagesLocationComparison = [];
      if (this.range !== 'all_time') {
        let urls = data.items.map(a => a.url);
        //console.log(urls);
        comparison = await comparisonService.postAsync(urls);
        comparison.sort((a, b) => {
          return urls.findIndex(x => x === a.url) - urls.findIndex(x => x === b.url);
        });
        let pagesLocationColumnValues = pagesLocationData.items.map(a => a[groupByColumn]);
        if (pagesLocationColumnValues && pagesLocationColumnValues.length > 0) {
          pagesLocationComparison = await pagesLocationComparisonService.postAsync(pagesLocationColumnValues);
          pagesLocationComparison.sort((a, b) => {
            return pagesLocationColumnValues.findIndex(x => x === a[groupByColumn]) - pagesLocationColumnValues.findIndex(x => x === b[groupByColumn]);
          });
        }
      }

      //console.log(comparison);
      this.data = data.items;
      this.pagination = data.pagination;
      this.comparison = comparison;
      this.pagesLocationData = pagesLocationData.items;
      this.pagesLocationPagination = pagesLocationData.pagination;
      this.pagesLocationComparison = pagesLocationComparison;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    } catch (err) {
      this.error = true;
      this.errorMessage = err.message;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    }
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        pagination: this.pagination,
        params: this.props.params,
        comparison: this.comparison,
        pagesLocationData: this.pagesLocationData,
        pagesLocationPagination: this.pagesLocationPagination,
        pagesLocationComparison: this.pagesLocationComparison
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  ActivityPagesViewComponent
};